module.exports = __webpack_public_path__ + "static/media/AddList.dbccb5c1.svg";